
<template>
  <div>
    <messagePopup
      dialogTitle="易派客提醒您："
      :dialogType="''"
      :centerDialogVisible="dialogVisible"
      @updateVisible="dialogVisible = false"
      @resetPopupData="dialogVisible = false"
      :popupWidth="'420px'"
      :showBtn="false"
      :showClose="false"
    >
      <div class="box">
        <div class="title">您的真实姓名尚未填写，请您填写！</div>
        <el-form :rules="rules" ref="form" :model="form" label-width="100px">
          <el-form-item label="真实姓名：" prop="name">
            <el-input
              maxlength="20"
              v-model.trim="form.name"
              placeholder="请输入您的真实姓名"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="next_btn">
          <div class="btn" @click="handleSubmit('form')">提交</div>
        </div>
      </div>
    </messagePopup>
  </div>
</template>

<script>
import { callBackUrl } from "../../modules/projectA/api/config";
import messagePopup from "./e-messagePopup.vue";
import api from "../../modules/projectA/api/nesting";
import api2 from "../../modules/projectA/api/login";
import { debounce } from "@/modules/projectA/utils/throttle.js"
export default {
  components: {
    messagePopup,
  },
  data () {
    const validateStrLen = (value) => {
      let len = 0;
      for (let i = 0; i < value.length; i++) {
        let c = value.charCodeAt(i);
        //单字节加1
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
          len++;
        }
        else {
          len += 2;
        }
      }
      return len;
    }
    const validateName = (rule, value, callback) => {
      let reg = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/;
      if (value == "") {
        callback(new Error('请输入用户名'))
      } else if (!reg.test(value)) {
        callback(new Error('请不要输入特殊字符'))
      } else if (validateStrLen(value) > 20) {
        callback(new Error('请不要超过20个字符(字母1个字符,文字2个字符)'))
      }
      callback();
    }
    return {
      gateway: "https://uat-gateway.epec.com/ssoLogin/callback?from=CORP_WEB_SITE",
      afterLoginUrl: "&afterLoginUrl=" + callBackUrl,
      dialogVisible: false,
      form: {
        name: ''
      },
      rules: {
        name: [{ required: true, validator: validateName, trigger: "blur" }],
      },
    }
  },
  created () {
    this.getContextObjectAndRemark();
  },
  mounted () {

  },
  computed: {

  },
  methods: {
    handleSubmit (form) {
      debounce(() => {
      this.$refs[form].validate((valid) => {
        if (valid) {
          api.upadateRealname({ realName: this.form.name }).then(res => {
            if (res.code == "200" && res.data?.returnResult) {
              this.$message.success("修改成功，请重新登录");
              this.dialogVisible = false;
              let timer = setTimeout(() => {
                this.longOut()
                clearTimeout(timer)
              }, 2000)
            } else {
              this.$message.error("修改失败");
              this.dialogVisible = false;
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },1000)
    },

    async getContextObjectAndRemark () {
      const userInfo = this.$store.state.USERINFO;
      if (userInfo?.memberSource === 'zhongjian') return;
      let res = await api.getContextObjectAndRemark({ bussType: "102" })
      if (res.code == "200") {
        if (res.data.returnResult == "true") {
          this.dialogVisible = false;
        } else {
          this.dialogVisible = true;
        }
      }
    },
    // 修改完重新登录
    async longOut () {
      let parmas = {
        callBackUrl: this.epecLoginUrl(),
      };
      let res = await api2.mallLoginOut(parmas);
      if (res.code == 200) {
        localStorage.clear();
        this.$cookies.remove("epecToken", '/', "epec.com");
        window.open(res.data, "_self");
      }
    },
    epecLoginUrl: function () {
      return encodeURIComponent(this.gateway + this.afterLoginUrl);
    },

  },


}
</script>

<style lang='scss' scoped>
.box {
  padding: 0 56px;
  .next_btn {
    width: 100%;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 12px;
    .btn {
      cursor: pointer;
      width: 80px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #2587ff;
      color: #fff;
      &:hover,
      :active {
        background-color: #126edf;
      }
    }
  }
  .title {
    width: 100%;
    height: 54px;
    color: #333;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
::v-deep.el-input--small .el-input__inner {
  border-radius: 0;
}
::v-deep.el-input__inner {
  width: 200px;
  border-radius: 0;
  color: #333;
}
::v-deep.el-form-item__label {
  font-size: 14px;
  color: #333;
}
::v-deep.el-form-item {
  margin: 0;
}
</style>
